export default "__VITE_ASSET__6041e20e__"